import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import brandsData from "../data/brandsData";

export default function Collections() {
    const { t } = useTranslation();
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedImage, setSelectedImage] = useState(null);

    const filteredData =
        selectedCategory === "All"
            ? brandsData
            : brandsData.filter((el) => el.category === selectedCategory);

    const showData = filteredData.map((el, index) => (
        <div
            className="w-100 w-[32%] h-[250px] rounded-[4px] border border-[#b58630] cursor-pointer opacity-0 animate-fadeIn"
            style={{ animationDelay: `${index * 0.1}s` }}
            key={el.id}
            onClick={() => setSelectedImage(el.image)}
        >
            <img className="w-full h-full object-cover" src={el.image} alt="" />
        </div>
    ));

    const closePopup = () => setSelectedImage(null);


    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex items-center justify-between">
                    <div className="w-100 w-[48%] flex flex-col">
                        <div className="f-40 text-[50px] font-bold capitalize text-[#b58630]">{t("Collections")}</div>
                        <div className="font-bold text-[20px] capitalize flex items-center gap-[7px]">
                            <Link to={"/"}>{t("home")}</Link>
                            -
                            <div className="text-[#b58630]">{t("Collections")}</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[20px]">
                    <div className="f-col flex items-center gap-[8px]">
                        <button
                            className={`w-100 py-[5px] px-[20px] rounded-[4px] transition-all duration-300 ${selectedCategory === "All"
                                ? "bg-[#b58630] text-white"
                                : "bg-white text-[#b58630] shadow-[0_0_10px_#0000002b]"
                                }`}
                            onClick={() => setSelectedCategory("All")}
                        >
                            {t("All")}
                        </button>
                        <button
                            className={`w-100 py-[5px] px-[20px] rounded-[4px] transition-all duration-300 ${selectedCategory === "medical"
                                ? "bg-[#b58630] text-white"
                                : "bg-white text-[#b58630] shadow-[0_0_10px_#0000002b]"
                                }`}
                            onClick={() => setSelectedCategory("medical")}
                        >
                            {t("Medical")}
                        </button>
                        <button
                            className={`w-100 py-[5px] px-[20px] rounded-[4px] transition-all duration-300 ${selectedCategory === "sports"
                                ? "bg-[#b58630] text-white"
                                : "bg-white text-[#b58630] shadow-[0_0_10px_#0000002b]"
                                }`}
                            onClick={() => setSelectedCategory("sports")}
                        >
                            {t("Sports")}
                        </button>
                        <button
                            className={`w-100 py-[5px] px-[20px] rounded-[4px] transition-all duration-300 ${selectedCategory === "modern"
                                ? "bg-[#b58630] text-white"
                                : "bg-white text-[#b58630] shadow-[0_0_10px_#0000002b]"
                                }`}
                            onClick={() => setSelectedCategory("modern")}
                        >
                            {t("Modern")}
                        </button>
                    </div>

                    <div className="flex flex-wrap gap-[20px] justify-between">
                        {showData}
                    </div>
                </div>
            </section>

            {/* Pop-up */}
            {selectedImage && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="w-90 relative bg-white p-4 rounded-[8px] w-[600px] h-[600px] animate-popIn">
                        <button
                            className="absolute top-2 right-2 text-[24px] font-bold bg-red-500 w-[30px] h-[30px] rounded-full flex items-center justify-center text-center text-white"
                            onClick={closePopup}
                        >
                            <img className="w-[12px] h-[12px]" src={require("../../assets/icons/x.svg").default} alt="" />
                        </button>
                        <img
                            className="w-full h-full object-contain"
                            src={selectedImage}
                            alt="Enlarged"
                        />
                    </div>
                </div>
            )}
        </>
    );
}